import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDXyarXvxvuYd3uZZvQTaaptkt98gfIMOY",
  authDomain: "cost-tracker-soho.firebaseapp.com",
  projectId: "cost-tracker-soho",
  storageBucket: "cost-tracker-soho.firebasestorage.app",
  messagingSenderId: "1006825875087",
  appId: "1:1006825875087:web:85478dee8831f56e2532fa"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
